<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
      style="background-color: #181F33"
    >
      <language-menu></language-menu>
      <units-menu></units-menu>
      <user-menu
        v-if="!$auth.loading && $auth.isAuthenticated && groups.length > 1"
      ></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Dashboard', icon: 'dashboard', path: '/' }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Open Uploads',
            icon: 'pending',
            path: '/open-uploads',
          }"
          v-if="groupServices.includes('pipescanner-inspections')"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Pipescanner ' + $t('menu.results'),
            icon: 'analytics',
            path: '/pipescanner-results',
          }"
          v-if="groupServices.includes('pipescanner-inspections')"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Analyser',
            icon: 'scatter_plot',
            path: '/pipescanner-analyser',
          }"
          v-if="
            groupServices.includes('pipescanner-inspections') &&
              permissions.includes('use:analyser')
          "
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Tools',
            icon: 'mouse',
            path: '/tools',
          }"
          v-if="
            groupServices.includes('pipescanner-inspections') &&
              permissions.includes('add:tool')
          "
        >
        </sidebar-item>

        <li class="">
          <a class="nav-link" v-on:click="logout"
            ><i class="md-icon md-icon-font md-theme-default">exit_to_app</i>
            <p>Logout</p></a
          >
        </li>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar v-if="!$auth.loading && $auth.isAuthenticated"></top-navbar>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view
            v-if="!$auth.loading && $auth.isAuthenticated"
          ></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
//import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import LanguageMenu from "./Extra/LanguageMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { mapState, mapMutations } from "vuex";
import axios from "axios";
import UnitsMenu from "./Extra/UnitsMenu.vue";
require("mapbox-gl/dist/mapbox-gl.css");

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    ZoomCenterTransition,
    UserMenu,
    LanguageMenu,
    UnitsMenu,
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "",
      sidebarMini: true,
      sidebarImg: true,
      groups: [],
    };
  },
  methods: {
    ...mapMutations([
      "SET_GROUP_SELECTED",
      "SET_GROUP_SERVICES",
      "SET_PERMISSIONS",
      "SET_LANGUAGE",
      "SET_EXPORT_SETTINGS",
      "SET_UNITS",
    ]),
    /**
     * This function completely logs-out the user (including the removal of cookies)
     */
    async logout() {
      // logout method
      await this.$auth.logout({
        returnTo: process.env.VUE_APP_SERVER_INGRESS,
      });
      await this.$cookies.keys().forEach((element) => {
        this.$cookies.remove(element);
      });
    },
    /**
     * This function functions as a sidebar toggle
     */

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    /**
     * This function locks the sidebar in place.
     */
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    /**
     * this function fetches the services a group is allowed to use.
     * @param {String} group -  the name of the group
     */
    async get_services_for_group(group) {
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.clients.services + group;

      axios
        .get(endpoint, header)
        .then((response) => {
          this.SET_GROUP_SERVICES(response.data.map((obj) => obj.service));
          var langs = response.data.map((obj) => {
            if (Object.keys(obj).includes("settings")) {
              return obj.settings.language;
            } else {
              return null;
            }
          });
          var unitsSettings = response.data.map((obj) => {
            if (Object.keys(obj).includes("settings")) {
              return obj.settings.units;
            } else {
              return null;
            }
          });
          response.data.forEach((entry) => {
            if (entry.service == "pipescanner-inspections") {
              this.SET_EXPORT_SETTINGS(entry.exportSettings);
            }
          });
          var language = null;
          langs.forEach((entry) => {
            if (entry) {
              language = entry;
            }
          });
          unitsSettings.forEach((entry) => {
            if (entry) {
              this.SET_UNITS(entry);
            }
          });
          //console.log(language);
          this.SET_LANGUAGE(language);
          if (this.language) {
            this.$i18n.locale = language;
          }
          //console.log(this.groupServices);
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
          this.SET_GROUP_SERVICES([]);
        });
    },
  },
  updated() {
    //reinitScrollbar();
  },
  computed: {
    /**
     * Computed property inteded to watch
     * @return {bool} Boolean indicating loading auth0 plugin.
     */
    authLoading() {
      return this.$auth.loading;
    },
    /**
     * Computed property inteded to watch
     * @return {bool} Boolean indicating authentication process status
     */
    authenticated() {
      return this.$auth.isAuthenticated;
    },
    ...mapState([
      "language",
      "groupSelected",
      "groupServices",
      "apiEndpoints",
      "permissions",
      "units",
    ]),
  },
  async mounted() {
    //reinitScrollbar();
    this.$sidebar.toggleMinimize();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
    /**
     * This wacther checks if auht0 plugin is still loading
     * @param {Bool} newValue - boolean indicating loading of plugin
     */
    authLoading(newValue) {
      console.log(newValue);
      if (!this.$auth.isAuthenticated) {
        this.$auth.loginWithRedirect();
      }
    },
    /**
     * Change in units
     * @param {str} newValue - string indicating which units to be used
     */
    units(newVal) {
      console.log(newVal);
    },
    /**
     * This wacther checks if authentication is happening
     * @param {Bool} newValue - boolean indicating success or failure of authentication
     */
    authenticated(newValue) {
      if (newValue) {
        //if authentication has passed, get the groups from the token and select the first one
        this.$auth.getPayload().then((payload) => {
          this.groups = payload["https://acqgroups.cloud/groups"];
          this.SET_GROUP_SELECTED(this.groups[0]);
        });

        this.$auth
          .getPermissions()
          .then((permissions) => {
            this.SET_PERMISSIONS(permissions);
            console.log(permissions);
          })
          .catch((error) => {
            //console.log(error);
            this.$notify({
              message: error,
              icon: "error",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger",
            });
          });
      }
    },
    /**
     * This watcher checks if a change of group selection has happened
     * @param {Bool} newGroup - boolean indicating success or failure of authentication
     */
    groupSelected(newGroup) {
      //if a new group is selected, fetch the services of this group and redirect to dashboard.
      this.get_services_for_group(newGroup);
      if (this.$route.path !== "/") this.$router.push("/");
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
